import { ButtonGroup } from '@mui/material';
import { DataGridPremiumProps, GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import LinkEnhancedButton from 'components/ui/buttons/LinkEnhancedButton';
import { loadingActions } from 'store';
import toast from 'shared/utils/toast';
import TenantPage from 'layouts/TenantPage';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { inventoryCheckService } from 'shared/services';
import InventoryCheckDetailPanel from '../components/InventoryCheckDetailPanel';
import { InventoryCheckAlternativeColumns } from '../inventory-check-alternative';
import { InventoryCheckColumns } from '../inventory-check';

export const InventoryCheck = () => {
  const translationPrefix = 'pages.inventory-check';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [_, setMessage] = useState('');

  const handleInventoryCheckServiceValidation = (id: number) => {
    setMessage(t(`${translationPrefix}.message`));
    loadingActions.startLoading();
    inventoryCheckService.validate(id.toString()).then(() => {
      toast.info(t(`${translationPrefix}.validation-started`));
    });
    loadingActions.stopLoading();
  };

  const handleInventoryCheckServiceArchive = (id: number) => {
    inventoryCheckService.archive(id.toString()).then(() => {
      toast.success(t('actions.successfully.archived'));
      datagridRefresh.current();
    });
  };

  const aggregatedColumns: GridColDef[] = InventoryCheckAlternativeColumns(
    handleInventoryCheckServiceValidation,
    handleInventoryCheckServiceArchive
  );

  const columns: GridColDef[] = InventoryCheckColumns();

  const getDetailPanelContent = useCallback<
    NonNullable<DataGridPremiumProps['getDetailPanelContent']>
  >(({ row }) => <InventoryCheckDetailPanel row={{ ...row }} columns={columns} />, [columns]);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <ButtonGroup>
          <AddEnhancedButton prefix={translationPrefix} to="new" />
          <LinkEnhancedButton
            label="global.archive"
            to="archive"
            requirePermission={'tenantAdmin'}
          />
        </ButtonGroup>
      }>
      <EnhancedDataGrid
        columns={aggregatedColumns}
        service={inventoryCheckService}
        refresh={datagridRefresh}
        getDetailPanelContent={getDetailPanelContent}
      />
    </TenantPage>
  );
};

export default InventoryCheck;
